import GenerateSalesOrder from './GenerateSalesOrder'

export default GenerateSalesOrder
